import { render } from "./AppHub.vue?vue&type=template&id=9569114c&scoped=true"
import script from "./AppHub.vue?vue&type=script&lang=js"
export * from "./AppHub.vue?vue&type=script&lang=js"

import "./AppHub.vue?vue&type=style&index=0&id=9569114c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9569114c"]])

export default __exports__